<template>
  <div>
    <ex-card class="ex-toolbar-product ex-toolbar-product-action pa-0">
      <div class="d-flex align-center">
        <v-btn
          text
          outlined
          color="primary"
          class="ex-move-delete-btn ml-2"
          :disabled="
            !deleteUrlPayload.product_ids.length ||
            !deleteUrlPayload.track_ids.length ||
            !deleteUrlPayload.url_ids.length
          "
          @click="moveDialog = true"
        >
          Move
          <!-- <span class="btn-down-right" > </span> -->
          <!-- <span class="btn-down-right" @click="deleteDialog = true">Delete</span> -->
          <!-- <v-icon @click="deleteDialog = true">close</v-icon> -->
        </v-btn>
        <v-btn
          text
          outlined
          color="primary"
          class="ex-move-delete-btn ml-1"
          :disabled="
            !deleteUrlPayload.product_ids.length ||
            !deleteUrlPayload.track_ids.length ||
            !deleteUrlPayload.url_ids.length
          "
          @click="deleteDialog = true"
        >
          Delete
          <!-- <span class="btn-down-right"></span> -->
        </v-btn>
        <v-btn depressed text class="ml-1 red--text" @click="moveTop">
          <v-icon>
            vertical_align_top
          </v-icon>
        </v-btn>
      </div>
    </ex-card>
    <v-dialog v-model="moveDialog" persistent max-width="1000">
      <v-card>
        <v-card-title class="headline">Please select product to move link</v-card-title>
        <v-card-text>
          <!--    Filters       -->
          <template>
            <div>
              <v-layout wrap align-start>
                <v-flex xs10 sm2>
                  <v-autocomplete
                    @change="updateByFilters($event, 'brand')"
                    :value="getSelectedFiltersMove.brand"
                    :items="getBrandsMove"
                    :loading="filtersMove.brand.isLoading"
                    :search-input.sync="filtersMove.brand.search"
                    noFilter
                    :ripple="false"
                    background-color="rgba(48, 127, 255, 0.1)"
                    clearable
                    hide-details
                    clear-icon
                    append-icon="expand_more"
                    item-text="value"
                    item-value="id"
                    label="Brand:"
                    class="mr-2"
                    solo
                    text
                  />
                </v-flex>
                <v-flex xs10 sm2>
                  <v-autocomplete
                    @change="updateByFilters($event, 'product')"
                    :value="getSelectedFiltersMove.product"
                    :items="getProductsMove"
                    :loading="filtersMove.product.isLoading"
                    :search-input.sync="filtersMove.product.search"
                    noFilter
                    :ripple="false"
                    background-color="rgba(48, 127, 255, 0.1)"
                    clearable
                    hide-details
                    clear-icon
                    append-icon="expand_more"
                    item-text="value"
                    item-value="id"
                    label="Name:"
                    class="mr-2"
                    solo
                    text
                  />
                </v-flex>
                <v-flex xs10 sm2>
                  <v-autocomplete
                    @change="updateByFilters($event, 'sku')"
                    :value="getSelectedFiltersMove.sku"
                    :items="getSkusMove"
                    :loading="filtersMove.sku.isLoading"
                    :search-input.sync="filtersMove.sku.search"
                    noFilter
                    :ripple="false"
                    background-color="rgba(48, 127, 255, 0.1)"
                    clearable
                    hide-details
                    clear-icon
                    append-icon="expand_more"
                    item-text="value"
                    item-value="id"
                    label="SKU:"
                    class="mr-2"
                    solo
                    text
                  />
                </v-flex>
                <v-flex xs10 sm2>
                  <v-btn
                    text
                    :ripple="false"
                    class="ex-btn ex-primary-btn"
                    @click="searchProducts()"
                  >
                    search
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </template>
          <ex-card disable-offsets>
            <template>
              <v-data-table
                :items="productsDataMove"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                :hide-headers="true"
                class=""
                v-if="productsDataMove.length"
              >
                <template v-slot:items="props">
                  <tr>
                    <td>
                      <v-btn
                        text
                        :ripple="false"
                        class="ex-btn ex-primary-btn"
                        @click="moveLinks(props.item)"
                      >
                        Move
                      </v-btn>
                    </td>
                    <td>{{props.item.manufacturer_name}}</td>
                    <td>
                      <v-tooltip top color="rgba(40, 39, 50, 1)">
                        <template v-slot:activator="{ on }">
                          <div v-on="on">
                            {{props.item.product_name}}
                          </div>
                        </template>
                        <span>Product Id: {{props.item.product_id}}</span>
                      </v-tooltip>

                    </td>
                    <td>
                      <div v-for="(i, index) in props.item.client_variation" :key="index">{{i.sku}}</div>
                    </td>
                    <td>
                      <div v-for="(i, index) in props.item.client_variation" :key="index">{{i.color}}</div>
                    </td>
                    <td>
                      <div v-for="(i, index) in props.item.client_variation" :key="index">{{i.size}}</div>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </template>
          </ex-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            :ripple="false"
            class="ex-btn ex-primary-btn text--white"
            @click="moveDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">Deleting, are you sure?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            :ripple="false"
            :loading="loading"
            class="ex-btn ex-primary-btn text--white"
            @click="deleteDialog = false"
          >
            No
          </v-btn>
          <v-btn
            text
            :ripple="false"
            :loading="loading"
            class="ex-btn ex-primary-btn text--white"
            @click="deleteSelectedLinks()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <notifications group="move" position="top center" :max="3" width="350">
      <template slot="body" slot-scope="props">
        <div class="default-notification save-notification">
          <a class="close" @click="props.close">
            <v-icon>close</v-icon>
          </a>
          <a class="title">
            {{ props.item.title }}
          </a>
          <p v-html="props.item.text"></p>
        </div>
      </template>
    </notifications>
  </div>
</template>

<script>
export default {
  name: 'ProductAction',
  props: {
    searchData: {
      type: [Object, Array],
      default: null
    },
    selectedProductList: {
      type: [Object, Array],
      default: null
    },
    trackIds: {
      type: [Object, Array],
      default: null
    },
    productInfo: {
      type: [Object, Array],
      default: null
    },
    dataOfClients: {
      type: [Object, Array],
      default: null
    },
    deleteUrlPayload: {
      type: [Object, Array],
      default: null
    }
  },
  data: () => ({
    loading: false,
    clientIdForLink: 0,
    deleteDialog: false,
    rowsPerPageItems: [50, 100, 200, 400],
    pagination: {
      rowsPerPage: 200
    },
    moveDialog: false,
    productsDataMove: [],
    filtersMove: {
      brand: {
        isLoading: false,
        search: null
      },
      product: {
        isLoading: false,
        search: null
      },
      sku: {
        isLoading: false,
        search: null
      },
      allowRequest: true
    }
  }),
  watch: {
    'filtersMove.brand.search': function (val) {
      if (val === '') {
        this.$store.commit('productModule/RESET_currentFilter', { key: 'brand' })
        return
      }
      if (this.getBrands && this.getBrands.find(el => val === el.name)) return
      let vm = this
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.filtersMove.brand.isLoading = true
        this.$store.dispatch('productModule/getBrands', {
          brandName: val,
          productId: vm.getSelectedFiltersMove.product,
          skuId: vm.getSelectedFiltersMove.sku
        }).then((res) => {
          this.$store.commit('productModule/SET_BRANDS_MOVE', res.data.brands)
          // commit('SET_BRANDS', response.data.brands)
          this.filtersMove.brand.isLoading = false
        })
      }, 300)
    },
    'filtersMove.product.search': function (val) {
      if (val === '') {
        this.$store.commit('productModule/RESET_currentFilter', { key: 'product' })
        return
      }
      if (this.getProducts && this.getProducts.find(el => val === el.name)) return
      let vm = this
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.filtersMove.product.isLoading = true
        this.$store.dispatch('productModule/getProducts', {
          productName: val,
          brandId: vm.getSelectedFiltersMove.brand,
          skuId: vm.getSelectedFiltersMove.sku
        }).then((res) => {
          this.$store.commit('productModule/SET_PRODUCTS_MOVE', res.data.products)
          this.filtersMove.product.isLoading = false
        })
      }, 300)
    },
    'filtersMove.sku.search': function (val) {
      if (val === '') {
        this.$store.commit('productModule/RESET_currentFilter', { key: 'sku' })
        return
      }
      if (this.getSkus && this.getSkus.find(el => val === el.name)) return
      let vm = this
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.filtersMove.sku.isLoading = true
        this.$store.dispatch('productModule/getSkus', {
          skuName: val,
          productId: vm.getSelectedFiltersMove.product,
          brandId: vm.getSelectedFiltersMove.brand,
          clientId: this.clientIdForLink
        }).then((res) => {
          this.$store.commit('productModule/SET_SKUS_MOVE', res.data)
          this.filtersMove.sku.isLoading = false
        })
      }, 300)
    }
  },
  methods: {
    updateByFilters (e, key) {
      if (!this.filtersMove.allowRequest) return
      this.$store.commit('productModule/SET_selectedFiltersMove', { value: e, key: key })
    },
    searchProducts () {
      let obj = {
        client_id: this.clientIdForLink,
        product_id: this.$store.state.productModule.selectedFiltersMove.product,
        brand_id: this.$store.state.productModule.selectedFiltersMove.brand,
        sku: this.$store.state.productModule.selectedFiltersMove.sku
      }
      this.$store.dispatch('productModule/loadProducts', obj).then((res) => {
        console.log(res)
        this.productsDataMove = res.data
      })
    },
    openDialog () {
      this.$emit('showProductList')
      this.searchData.dialogData.show = true
    },
    moveLinks (productId) {
      this.$emit('moveLinks', productId)
    },
    deleteSelectedLinks () {
      this.$emit('deleteLinks')
      this.deleteDialog = false
    },
    moveTop () {
      window.scrollTo({top: 0, behavior: 'smooth'})
    },
    productMoved () {
      this.$notify({
        group: 'move',
        title: 'Link moved',
        text: 'Link moved',
        duration: 500,
        speed: 600
      })
    }
  },
  computed: {
    isOpen () {
      return this.$store.state.sidebarModule.isOpen
    },
    getBrandsMove () {
      return this.$store.state.productModule.brandsMove
    },
    getProductsMove () {
      return this.$store.state.productModule.productsMove
    },
    getSkusMove () {
      return this.$store.state.productModule.skusMove
    },
    getSelectedFiltersMove () {
      return this.$store.state.productModule.selectedFiltersMove
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/product/ProductActions.vue